import script from "./TranslatorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorPanel.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorPanel.vue?vue&type=style&index=0&id=1fcb4a73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcb4a73"]])

export default __exports__